
// CSS Styling
import "../styles/socialMedia.css";

// Icons
import TwitterBlack from "../images/icons/TwitterBlack.png"
import FacebookBlack from "../images/icons/FacebookBlack.png"
import LinkedInBlack from "../images/icons/LinkedInBlack.png"
import MessageBlack from "../images/icons/MessageBlack.png"
import UrlBlack from "../images/icons/UrlBlack.png"

const SocialMedia = ({ twitterURL, facebookURL, linkedinURL, mailSubject, mailContent, copyLink }) => {
    return(
        <div className="componentSocialMedia">
            <a href={`https://www.facebook.com/sharer/sharer.php?u=${facebookURL}&quote=Check%20ISA%20Blog!"`} target="_blank" rel="noopener noreferrer"><img src={FacebookBlack} alt="Share on Facebook"/></a>
            <a href={`https://twitter.com/intent/tweet?text=Check%20ISA%20Blog!&url=${twitterURL}`} target="_blank" rel="noopener noreferrer"><img src={TwitterBlack} alt="Share on Twitter"/></a>
            <a href={`https://www.linkedin.com/sharing/share-offsite/?url=${linkedinURL}`} target="_blank" rel="noopener noreferrer"><img src={LinkedInBlack} alt="Share on LinkedIn"/></a>
            <a href={`https://mail.google.com/mail/u/0/?view=cm&to&su=${mailSubject}&body=${mailContent}%0A&bcc&cc&fs=1&tf=1`} target="_blank" rel="noopener noreferrer"><img src={MessageBlack} alt="Share by email"/></a>
            <a href="#" onClick={copyLink}><img src={UrlBlack} alt="Copy link"/></a>
        </div>
    )
}

export default SocialMedia